<template>
    <el-drawer
        title="工作人员导入"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-upload 
                drag 
                action
                :http-request="uploadExcel"
                :auto-upload="false"
                ref="upload"
                accept=".xls, .xlsx"
                :show-file-list="true"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :on-change="onChange"
                :on-remove="onRemove"
                :disabled="uploadLoading">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传xls、xlsx文件，且最多不超过1000行
                </div>
            </el-upload>
            
            <div class="color-info">
                导入文件示例如下:
                <el-button 
                    v-if="$utils.have('/userPermit/downloadTemplate')" 
                    type="text" 
                    icon="el-icon-download" 
                    @click="download"
                    :loading="downLoading">
                    点击下载模板
                </el-button>
            </div>
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                size="small"
            >
                <el-table-column prop="name" label="姓名" width="50"></el-table-column>
                <el-table-column prop="telephone" label="手机" min-width="120"></el-table-column>
                <el-table-column prop="activityIds" label="绑定演出" min-width="120"></el-table-column>
                <el-table-column prop="remarks" label="备注" min-width="120"></el-table-column>
            </el-table>
            <div class="from-tip">
                <span class="el-icon-warning"></span>
                绑定演出如果有多个，请使用<b>英文斜线/分隔演出ID,证件有效期默认以演出开始结束时间为准</b>，如需调整请手动编辑。 
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
                >导入</el-button>
        </div>
        <ErrorMsgDrawer ref="errorMsgDrawer"></ErrorMsgDrawer> 
    </el-drawer>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    components:{ErrorMsgDrawer},
    data() {
        return {
            drawerShow:false,
            btnLoading: false,
            downLoading:false,
            uploadLoading:false,
            dataList:[{
                name:'张三',
                telephone:'188 8888 8888',
                activityIds:'110695',
                remarks:'备注内容，选填'
            },{
                name:'李四',
                telephone:'199 9999 9999',
                activityIds:'110696/110697',
                remarks:'备注内容，选填'
            }],
            canSubmit:true,
            fileList:[],
        };
    },
    methods: {
        show() {
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        onSubmit() {
            this.$refs.upload.submit();
        },
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/userPermit/batchImport',
                method: 'post',
                data:{fileUrl:filePath}
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result){
                            this.$refs.errorMsgDrawer.show(result);
                        }else{
                            this.onSuccess();
                        }
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.$refs.upload.clearFiles();
                    this.btnLoading = false;
                    this.canSubmit = true;
                });

        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess(){
            this.$emit('onUpdate');
            this.close();
        },
        //下载模板
        async download(){
            this.downLoading = true;
            let filePath;
            const res = await this.$request({
                url:'/userPermit/downloadTemplate',
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 && url){
                filePath = url;
            }else{
                this.downLoading = false;
                this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'工作人员.xlsx');
            this.downLoading = false;

        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-danger;
    }
}
</style>